import { defineStore } from 'pinia';
import { TipCollectionType } from "~/types/tip/TipCollectionType";
import { TipPreviewEntity } from "~/entities/tip/TipPreviewEntity";

export const useTipsPageStore = defineStore({
    id: 'useTipsPageStore',
    state: (): TipCollectionType => ({
        list: undefined,
        pagination: undefined,
        error: undefined,
    }),
    getters: {
        getGridsTips(store: TipCollectionType) {
            if (store.list === undefined) {
                return undefined;
            }

            let iterationIndex = 0;
            let gridIndex = 0;
            const grid = [[], [], [], []];
            const maxGridIndex = grid.length - 1;
            store.list.forEach((item) => {
                grid[gridIndex].push(Object.assign(
                    item,
                    {
                        color: iterationIndex%3 === 0 ? 'yellow' : iterationIndex%3 === 1 ? 'red' : 'orange',
                    }
                ));
                gridIndex++;
                iterationIndex++;
                if (gridIndex > maxGridIndex) {
                    gridIndex = 0;
                }
            });

            return grid;
        },

        getList(store: TipCollectionType) {
            if (store.list === undefined) {
                return undefined;
            }

            return store.list.map((item, index) => {
                return Object.assign(item, {
                    color: index%2 === 0 ? 'yellow' : index%3 === 1 ? 'red' : 'orange'
                });
            });
        }
    },
    actions: {
        clear() {
            this.list = undefined;
            this.pagination = undefined;
            this.error = undefined;
        },

        async fetchList(page: number, search: string = '') {
            if (this.pagination?.pageCount < page) {
                return true;
            }

            const pageSize = 32;

            try {
                const params = {
                    fields: ['title', 'slug', 'text'],
                    sort: ['publishedAt:desc'],
                    'pagination[page]': page,
                    'pagination[pageSize]': pageSize,
                };

                if (search) {
                    params['filters[$or][0][title][$contains]'] = search;
                    params['filters[$or][1][text][$contains]'] = search;
                }

                const response = await this.$useNuxtApp.axios.get('/tips', {params});

                if (response?.data?.data === undefined || this.error !== undefined) {
                    this.error = createError({statusCode: 404, statusMessage: 'Page Not Found'});
                    this.pagination = undefined;
                    return false;
                }

                if (!response?.data?.data.length) {
                    this.list = [];
                    this.pagination = undefined;
                    return true;
                }

                if (page > 1 && this.list !== undefined) {
                    response?.data?.data.forEach((item) => {
                        this.list.push(TipPreviewEntity(item));
                    });
                } else {
                    this.list = response?.data?.data.map((item) => {
                        return TipPreviewEntity(item);
                    });
                }
                this.pagination = {
                    page: response?.data?.meta?.pagination?.page,
                    pageCount: response?.data?.meta?.pagination?.pageCount,
                };
                this.error = undefined;
            } catch (error) {
                console.log(error);
                this.error = createError({ statusCode: 500, statusMessage: 'Internal error' });
            }

            return true;
        }
    },
});
